import { z } from "zod";
import { fetchSymbol } from "../fetch/fetch-helper";
import { ShopifyProduct } from "types";

const endpoint = (handle: string) => `/product/${handle}.js`;

export async function get(handle:string, noInterceptors?: boolean) {
  const parseRes = z.string().safeParse(handle);
  if (!parseRes.success) throw new Error('Invalid handle');
  const product = await window[fetchSymbol].getJSON<ShopifyProduct>(endpoint(handle), undefined, noInterceptors);
  return product;
}
